import "./HeaderResponsive.styl";

import React from "react";
import { Link } from "react-router";
import { connect } from "react-redux";
import cn from "classnames";

import * as headerResponsiveActions from "./actions";

class HeaderResponsive extends React.Component {
  showMobileNav() {
    const { burgerMenu: { mobileMenuActive } } = this.props;
    const { showMobileMenu } = this.props;
    if (mobileMenuActive) {
      showMobileMenu(false);
      document.body.style.overflow = "scroll";
    } else {
      showMobileMenu(true);
      document.body.style.overflow = "hidden";
    }
  }

  hideMobileNav(e) {
    const { burgerMenu: { mobileMenuActive } } = this.props;
    const { showMobileMenu } = this.props;
    if (mobileMenuActive) {
      showMobileMenu(false);
    }
    document.body.style.overflow = "scroll";
  }

  render() {
    const {
      burgerMenu: { mobileMenuActive: isOpen, isShown },
      appPath
    } = this.props;
    const self = this;

    if (!isShown) return null;

    return (
      <div className="hidden-lg-up">
        <div
          className={cn(
            {
              active: isOpen
            },
            "navigation-header",
            "mobile-nav-visible"
          )}
        >
          <div onClick={this.hideMobileNav.bind(this)}>
            <Link className="logo" to={`${appPath}/`}>
              {"OpiekujSie.pl"}
            </Link>
          </div>
          <div
            className={isOpen ? "hamburger close" : "hamburger"}
            onClick={this.showMobileNav.bind(this)}
          >
            <div className="dash" />
            <div className="dash" />
            <div className="dash" />
            <div className="menu-text">menu</div>
          </div>
          <nav className="center-xs">
            <ul>
              <li onClick={this.hideMobileNav.bind(this)}>
                <Link activeClassName="active" to={`${appPath}/`}>
                  Oferty pracy
                </Link>
              </li>
              <li onClick={this.hideMobileNav.bind(this)}>
                <Link activeClassName="active" to={`${appPath}/blog`}>
                  Porady dla opiekunek
                </Link>
              </li>
              <li onClick={this.hideMobileNav.bind(this)}>
                <Link activeClassName="active" to={`${appPath}/kontakt`}>
                  Kontakt
                </Link>
              </li>
              <li className="enhanced" onClick={this.hideMobileNav.bind(this)}>
                <Link
                  activeClassName="active"
                  to={`${appPath}/dodaj-ogloszenie`}
                >
                  Dla pracodawców
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    burgerMenu: state.headerResponsive,
    appPath: state.config.appPath
  }),
  {
    ...headerResponsiveActions
  }
)(HeaderResponsive);



/** WEBPACK FOOTER **
 ** ./src/browser/components/HeaderResponsive/HeaderResponsive.js
 **/